import GameModel from "../core/src/model/GameModel";
import { State } from "../core/src/states/State";
import UIController from "../core/src/ui/UIController";
import { UIStates } from "../core/src/ui/UIStates";
import AutoplayModel from "../core/src/model/AutoplayModel";
import KeyboardManager, { Key } from "../core/src/utils/KeyboardManager";
import { UIUpdateEvent } from "../core/src/ui/UIUpdateEvents";
import RealityCheckModel from "../core/src/model/RealityCheckModel";
import CommManager from "../core/src/controllers/CommManager";
import RequestRegister from "../core/src/server/requests/RequestRegister";
import BetModel from "../core/src/model/BetModel";
import RelaxPOSTMessageController from "../server/RelaxPOSTMessageController";

export default class Idle extends State {
    protected realityCheckTimer;

    public enter(): void {
        super.enter();

        if (GameModel.shouldUpdateBalance) {
            this.makeBalanceRequest();
        } else {
            this.applyStateSettings();
        }
    }

    // /Users/icopenchev/Projects/ElectricElephant/MGS/NinjaQuest/assets/textures/static/assets/textures/chara-{n}.json

    protected makeBalanceRequest() {
        CommManager.send(
            RequestRegister.get("getBalance"),
            (data) => {
                GameModel.shouldUpdateBalance = false;
                BetModel.balance = data.b;
                this.applyStateSettings();
            },
            this
        );
    }

    protected applyStateSettings() {
        UIController.setState(UIStates.IDLE);
        GameModel.restoreData = null;
        UIController.updateFields(UIUpdateEvent.All);

        if (GameModel.shouldPauseGame) {
            RelaxPOSTMessageController.reportPaused();
            UIController.setState(UIStates.SPIN);
        }

        if (GameModel.hasRealityCheck) {
            let timeLeft = RealityCheckModel.getTimeTillTimeLimit();

            console.log("[EEIdleState] Reality check time left: " + timeLeft);

            if (timeLeft > 0) {
                this.realityCheckTimer = setTimeout(
                    this.forceRealityCheck.bind(this),
                    timeLeft
                );
            } else {
                this.forceRealityCheck();
            }
        }

        if (AutoplayModel.isAutoSpinActive()) {
            if (!GameModel.shouldStopAutoplay) {
                this.exit();
            } else {
                GameModel.shouldStopAutoplay = false;
                AutoplayModel.setAutoSpin(0);
            }
            return;
        }

        if (AutoplayModel.autoSpinLimitReached) {
            UIController.toggleComponent("autoplayLimitPopup");
        }

        if (KeyboardManager.isPressed(Key.SPACE) && GameModel.alowSpaceToSkipSpin()) {
            this.spinWithKey();
        } else {
            KeyboardManager.onKey("pressed", Key.SPACE, this.spinWithKey, this);
        }

        // For fullscreen testing. Do not delete
        // const scene = ViewManager.getLayer(DefaultLayers.Header).getCurrentScene()
        // let container = new PIXI.Container();
        // scene.addChild(container);
        // let text = new PIXI.Text();
        // container.addChild(text);
        // text.text = "window.screen.width" + window.screen.width + "\n innerWidth" + window.innerWidth + "window.screen.height" + window.screen.height + "\n innerHeight" + window.innerHeight
        //
        // App.dispatcher.on(GameEvents.RESIZE, () => {
        //     text.text = "window.screen.width" + window.screen.width + "\n innerWidth" + window.innerWidth + "window.screen.height" + window.screen.height + "\n innerHeight" + window.innerHeight
        // }, this);

        //
        //
        // const config = new BitmapMoneyFieldConfig();
        // const text = new BitmapMoneyField(config);
        // scene.addChild(text);
        // text.x = Layout.scalePixels(100);
        // text.value = 123123177;
        //
        // const config2 = new MoneyFieldConfig();
        // const text2 = new MoneyField(config2);
        // scene.addChild(text2);
        // text2.x = Layout.scalePixels(1400);
        // text2.value = 123123177;
        //
        // const num = {val: 11110};
        // TweenMax.to(num, 10, {val: 11000000, onUpdate: () => {
        //     text.value = num.val;
        //     text2.value = num.val;
        // }});

        // const currencyText = new MoneyField(config);
        // Layout.testSetWidth(currencyText, config.bounds.width);
        // scene.addChild(currencyText);
        // const moneyObj = {from: 0, to: 1123123123};
        // const moneyTween = TweenMax.to(moneyObj, 5, {from: moneyObj.to, RoundProps: true, onUpdate: () => {
        //     currencyText.value = Math.floor(moneyObj.from);
        //     }});
        // // TODO clean animations
        // // TODO enable UI
    }

    protected forceRealityCheck() {
        GameModel.forceRealityCheck = true;
        this.exit();
        return;
    }

    protected spinWithKey() {
        if (GameModel.spaceToSpin) {
            this.exit();
        }
    }

    public exit(): void {
        // Clear the RealityCheck timer - it will be checked on the next state change anyway
        if (this.realityCheckTimer) {
            clearTimeout(this.realityCheckTimer);
            this.realityCheckTimer = null;
        }

        KeyboardManager.offKey("pressed", Key.SPACE, this.spinWithKey, this);

        super.exit();
    }

    public canExit(): boolean {
        return true;
    }
}
